import React from 'react'
import Container from 'elements/Container'
import Modal from '../Modal'
import { useModalOpen, useToggleContactUsModal } from 'state/application/hooks'
import { ApplicationModal } from 'state/application/actions'
import { Label, TextInput, TextArea, SendButton, Wrapper, ModalTitle, Form } from './styled'

const Index = () => {
  const contactModalOpen = useModalOpen(ApplicationModal.CONTACT_US)
  const toggleContactModal = useToggleContactUsModal()

  return (
    <Container>
      {/* <SuccessModal />
    <BadgeModal />
    <button onClick={toggleBadgeModal}>TestModal</button> */}
      <Modal isOpen={contactModalOpen} onDismiss={toggleContactModal} minHeight={false} maxHeight={90}>
        <Wrapper>
          <ModalTitle>Contact Us</ModalTitle>
          <Form>
            <div>
              <Label>Full Name</Label>
              <TextInput type="text" name="fullname" id="" />
            </div>
            <div
              style={{
                paddingTop: '24px'
              }}
            >
              <Label>Message</Label>
              <TextArea name="message" rows={10}></TextArea>
            </div>
          </Form>
          <SendButton>Send</SendButton>
        </Wrapper>
      </Modal>
    </Container>
  )
}

export default Index
